export default {
  profile: {
    title: "Min profil",
    info: "Här kan du redigera din information, se bokade och ansökta mötestider samt företag du har intresserat dig för.",
    firstname: "Förnamn",
    lastname: "Efternamn",
    dateOfBirth: "Födelseår",
    email: "E-post",
    phone: "Telefonnummer",
    school: "Skola",
    program: "Program/Kurs",
    graduationYear: "Examinationsår",
    linkedIn: "LinkedIn",
    cv: "CV",
    uploadCV: "Ladda upp CV",
    interestedCompanies: "Företagsintresse",
    appliedContactMeetings: "Ansökta kontaktsamtalstider",
    schools: {
      sh: "Södertörns högskola",
      other: "Annan",
    },
    programs: {
      economics: "Ekonomie kandidat",
      interEconomics: "Internationella ekonomprogrammet",
      tourism: "Turismprogrammet",
      artCultureEconomy: "Konst, kultur och ekonomi",
      logisticsEconomy: "Logistik och ekonomi",
      econTechDesign: "Ekonomi, teknik och design",
      managementIT: "Management med IT",
      entrepreneurship: "Entreprenörskap, innovation och marknad",
      europeanStudies: "Europaprogrammet",
      ppeProgram: "Filosofi, politik och ekonomi",
      interculturalBusiness: "Interkulturellt företagande",
      sportManagement: "Sport management",
      journalism: "Journalistikprogrammet",
      teacher: "Lärarprogrammet",
      otherProgram: "Annat program",
      course: "Fristående kurs(er)",
    },
    unsavedChanges: "Osparade ändringar",
    noInterestedCompanies: "Du har inte intresserat dig för några företag än",
    bookedContactMeetings: "Bokade kontaktsamtal",
    bookingUnavailable: "Denna tid kan inte bli bokad",
    noBookedMeetings: "Inga möten bokade än",
    noAppliedMeetings: "Inga möten ansökta än",
    sameTimeBooking: "Du har ett möte bokat samma tid med ett annat företag",
    sameCompanyBooking: "Du har ett möte bokat med",
    otherPersonBooking: "Någon annan har bokat tiden",
    with: "med",
  },
  company: {
    company: "Företag",
    featured: "Utställare med kontaktsamtal",
    all: "Alla utställare",
    readMore: "Läs mer",
    founded: "Grundat",
    employees: "Antal anställda i Sverige",
    locations: "Platser",
    about: "Om oss",
    values: "Våra värderingar",
    name: "Namn",
    tags: "Taggar",
    interested: "Intresserad",
    notInterested: "Inte intresserad",
    contactMeeting: "Kontaktsamtal",
    applyContactMeeting: "Sök kontaktsamtal",
    chooseTimes: "Ansök om tider",
    removeAppliedTimes: "Ta bort ansökta tider",
    cancelRemoval: "Avbryt borttagning",
    removeTimes: "Ta bort tider",
    availableTimes: "Tillgängliga tider",
    downloadCv: "Ladda ned CV",
    interestRemoved: "Intresse borttaget",
    interestSaved: "Intresse sparat",
    addCompany: "Lägg till företag",
    meetingRoom: "Mötesrum",
    intro: {
      readAbout:
        'Här kan du läsa om företagen på mässan genom att klicka på "{readMore}", söka kontaktsamtal genom att klicka på "{requestMeeting}" och visa intresse genom att klicka på "{interested}".',
      contactMeeting:
        "Du söker kontaktsamtal genom att logga in och lägga till information i din profil. Sedan ansöker du om de tider du kan tänka dig att ha ett möte på hos de företag du är intresserad av. När du har ansökt om tider kan du se dessa i din profil. En representant från företaget kommer att titta på din ansökan och förhoppningsvis godkänna en av dina tider!",
      note: "OBS: Att ansöka om en tid innebär INTE att du har ett möte bokat, utan företagen måste GODKÄNNA en av dina ansökningar. Notera även att du kan inte ha mer än ett möte bokat hos samma företag och du kan heller inte ha fler än ett möte bokat samma tid.",
    },
    contactMeetingCardInfo:
      'Här söker du kontaktsamtal. Ansök om tider genom att markera tider och sedan klicka "Ansök". Ta bort tider du har sökt genom att klicka på "Ta bort ansökta tider" och sedan klicka på "Ta bort tider".',
    applyingNote:
      "OBS: Tider du ansöker om är INTE bokade, företaget måste GODKÄNNA ansökningen. När ett möte godkänns så får du en bekräftelse på din email.",
    noTimes: "Kontaktsamtalstider kommer att publiceras snart",
  },
  common: {
    edit: "Redigera",
    save: "Spara",
    cancel: "Avbryt",
    cancelAll: "Avbryt ändringar",
    notSelected: "Ej vald",
    saveAll: "Spara alla",
    close: "Stäng",
    apply: "Ansök",
    and: "och",
    remove: "Ta bort",
    goTo: "Gå till",
    bookMeeting: "Boka möte",
    cancelMeeting: "Avboka möte",
    either: "Antingen",
    date: "Datum",
    time: "Tid",
    madeBy: "Gjord av",
  },
  success: {
    profileUpdated: "Profil uppdaterad!",
    cvUploaded: "CV uppladdat!",
    timesRemoved: "Tider borttagna!",
    contactMeetingApplied: "Kontaktsamtalstider ansökta!",
    companySaved: "Företag sparat",
    bookMeeting: "Möte bokat",
    cancelMeeting: "Möte avbokat",
    employeeAdded: "Anställd tillagd",
    changePassword: "Lösenord ändrat!",
  },
  errors: {
    somethingWentWrong: "Något gick fel",
    tryAgainLater: "Försök igen senare",
    fetchProfile: "Kunde inte hämta profilinfo.",
    saveField: "Kunde inte spara ändringen.",
    cvUpload: "CV-uppladdning misslyckades.",
    register: {
      emailExists: "E-postadressen används redan",
      serverError: "Ett fel uppstod vid registrering",
      default: "Registrering misslyckades",
    },
    signedIn: "Du behöver vara inloggad",
    removeTimes: "Kunde inte ta bort tider",
    applyTimes: "Kunde inte ansöka om tider",
    notFoundPage: {
      pageDoesntExist: "Sidan finns inte",
      couldntBeFound: "Tyvärr, sidan du letar efter kunde inte hittas",
      homePage: "Gå till startsidan",
    },
    companySaved: "Företaget kunde inte sparas",
    acceptTermsLogin:
      "Du måste acceptera Integritetspolicyn och Användarvillkoren för att logga in",
    acceptTermsRegister:
      "Du måste acceptera Integritetspolicyn och Användarvillkoren för att registrera dig",
    bookMeeting: "Kunde inte boka möte",
    cancelMeeting: "Kunde inte avboka möte",
    fillAllFields: "Du måste fylla i alla fält",
    changePassword: "Kunde inte byta lösenord",
    signOutAndIn: "Försök att logga ut och sedan att logga in igen",
  },
  language: {
    sv: "Svenska",
    en: "English",
    date: "sv-SE",
  },
  header: {
    homePage: "Startsida",
    profile: "Profil",
    exhibitors: "Utställare",
    meetings: "Möten",
  },
  footer: {
    contact: "Kontakta oss",
    address: "Adress",
    support: "Support",
    questionContact: "Vid frågor, kontakta:",
  },
  login: {
    login: "Logga in",
    loggedIn: "Inloggad",
    logoutQuestion: "Vill du logga ut?",
    logout: "Logga ut",
    register: "Registrera dig",
    password: "Lösenord",
    accountExist: "Har du redan ett konto?",
    accountNotExist: "Har du inget konto?",
    loginHere: "Logga in här",
    registerHere: "Registrera dig här",
    acceptTerms: "Jag godkänner SÖFREs",
    privacyPolicy: "Integritetspolicy",
    termsOfUse: "Användarvillkor",
    changePassword: "Byt lösenord",
    currentPassword: "Nuvarande lösenord",
    newPassword: "Nytt lösenord",
    confirmPassword: "Bekräfta lösenord",
    validationRequired: "Validering krävs",
    passwordLength: "Ditt lösenord måste ha fem (5) eller fler tecken",
    passwordMatch: "Måste matcha det nya lösenordet",
  },
  home: {
    intro:
      "e-day är Södertörns högskolas arbetsmarknadsdag för ekonomer. För tjugofemte gången arrangerar Södertörns Förenade Ekonomer (SÖFRE) denna mässa som ger Södertörns studenter ett unikt tillfälle att träffa framtidens arbetsgivare. Den 10:e november kommer studenterna på Södertörns högskola kunna besöka årets upplaga av SÖFREs arbetsmarknadsdag för ekonomer, e-day.",
    meeting:
      "Ett kontaktsamtal är en intervju mellan en student och en representant från ett utställande företag på e-day som har valt att ha kontaktsamtal. Intervjuerna hålls under e-day, där bokning är 25 minuter varav 20 minuter är intervju och 5 minuter paus mellan intervjuerna för företaget. Detta ger företaget chansen att lära känna dig och vem du är. e-day är även en god möjlighet för dig som vill ha ett jobb vid sidan av studierna såväl som för dig som vill ha en god inblick på hur ett arbete inom ekonomisektorn kan se ut. Detta samtidigt som du får chansen att lära dig mer om företaget och knyta nya värdefulla kontakter. Du kan lära dig mer om företagets rekryteringsprocess och vad de letar efter hos dig som nyexaminerad student vid anställning.",
    member:
      "Missa inte denna chans att marknadsföra dig själv som framtidens arbetskraft till attraktiva arbetsgivare! För att få delta krävs även ett medlemskap i Södertörns Förenade Ekonomers krävs. Ett medlemskap är gratis och alla kan bli medlemmar här:",
    memberLink: "http://www.sofre.se/bli-medlem/",
    networking:
      "e-day är ett utmärkt tillfälle att träffa nya människor och nätverka, samt ta del av föreläsningar som ger en fördel för dig som student. Att vara aktiv under mässan och besöka många utställande företag ger dig en större chans att säkra din framtid.",
  },
  employee: {
    info: 'Här kan du se alla mötestider som studenter har ansökt om. Gå igenom alla studenters profiler och se över vilka studenter ni anser skulle passa på ett kontaktsamtal med er. Ni kan bara boka totalt "{availableTimes}". Ni kan också bara boka en tid per student och en student per tid. En del tider går inte att boka, detta kan bero på: studenten har redan en tid bokad med er, studenten har ett möte bokat den tiden eller så har ni bokat ett möte med en annan student på den tiden. Så se till att välja noga vilka studenter som ni bokar in och vilka tider de får!',
    youHave: "Ni har",
    freeTimes: "lediga tider",
    bookedMeetings: "bokade möten",
    applicants: "Studenter som ansöker till möten",
    applicantsInfo:
      'Nedan ser ni alla studenter som har ansökt till kontaktsamtal med er. Läs igenom deras profiler och boka ett möte med en student genom att klicka på "BOKA MÖTE". När ett möte bokas får studenten ett automatiskt bekräftelsemail.',
    meetingTimes: "Mötestider",
    bookingUnavailable: "Går ej att boka",
    book: "boka",
    cancel: "avboka",
    confirmCancelation: "Bekräfta avbokning",
    confirmBooking: "Bekräfta bokning",
    areYouSure: "Är du säker på att du vill",
    meetingWith: "mötet med",
    the: "den",
    at: "kl.",
    bookingNotPossible: "Varför går det inte att boka",
    alreadyBooked: "Studenten har redan ett möte bokat med ert företag",
    timeUnavailable: "Tiden är bokad med en annan student",
    studentUnavailable: "Studenten är upptagen med ett annat möte den tiden",
    addEmployee: "Lägg till anställd",
  },
};
